import {entity} from "../../components/ListComponentEntity";
import {NavLink} from "react-router-dom";
import React from "react";
import {NewList} from "../../components/NewList/NewList";

export const ListContactNew = (props) => {
    return (
        <NewList
            { ...props }
            entity={'contact'}
            entity_type={2}
            requiredFields={'id,name,type_id,work_phone,mobile_phone,email'}
            requiredExpand={'type'}
            deleteToShowColumn={'id,name,type,work_phone,mobile_phone,email'}
            additionalFieldsExists={true}
            isFilterExists={true}
            filterFields={entity.contact.fArr}
            singleSearch={entity.contact.fArr[0]}
            headingColumns={['ФИО', 'Статус', 'Почта', 'Телефоны']}
            analytics={'/order/report/'}
            RenderColumn={(item) => (
                <>
                    <td>
                        <NavLink to={`/contact/${item.id}`}  className={'nowrap-list-column'}>{item.name}</NavLink>
                    </td>
                    <td>
                        {item.type && <span className="label-st" style={{ backgroundColor: 'rgb(255, 193, 100)' }}>{item.type.value}</span>}
                    </td>
                    <td>
                        <div>{item.email}</div>
                    </td>
                    <td>
                        <div>{item.mobile_phone}</div>
                        <div>{item.work_phone}</div>
                    </td>
                </>
            )}
            createButtonRender={(setModalType) => <button onClick={() => setModalType('contact')} className="open-modal-button btni">Новый контакт</button>}
            rightNavbarConfig={{
                export: true,
                additionalFields: '/fieldsettings/2',
                columns: true,
                import: '/import/contact'
            }}
            massDoConfig={{ deleteAll: `/ajax/contact/delete-all` }}
            contextNav={{ edit: true, task: true, print: false, delete: true }}
            sort={entity.contact.fArr.filter(el => el.sort)}
        />
    )
}